/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AsCodeExpressionDto = {
    kind: AsCodeExpressionDto.kind;
};

export namespace AsCodeExpressionDto {

    export enum kind {
        FIELD = 'field',
        VALUE = 'value',
    }


}
